import numberWithCommas from './numberWithCommas';

const formatCash = (
  numInp = 0,
  currencyIcon = '',
  showDecimals = true,
  showDecimalIfNumberHasDecimal = false
) => {
  // if it is a not a number return number
  if (Number.isNaN(Number(numInp))) {
    return numInp;
  }

  // updates: this is because of a complain by the client regarding decimal not showing up when the number has decimal
  const numberHasDecimal = Number(numInp) - Math.floor(Number(numInp)) !== 0;
  const shouldShowDecimalBecauseNumberHasDecimal =
    showDecimalIfNumberHasDecimal && numberHasDecimal;

  const num =
    showDecimals || shouldShowDecimalBecauseNumberHasDecimal
      ? Number(numInp).toFixed(2)
      : Math.floor(Number(numInp));
  const str = num.toString().replace(/,/g, '');
  // eslint-disable-next-line no-param-reassign
  const currency = `${currencyIcon || ''}`;
  return currency + numberWithCommas(str);
};

export default formatCash;
